import React, { FC } from 'react';
import { getCsvFromECG } from 'api/services/study-service';
import { useAppDispatch, useAppSelector, useState } from 'hooks';
import { studyActions } from 'utils/store';
import { DownloadECGItem } from 'types/types';
import styles from './styles.module.sass';

type Properties = {
  holterFile: File | null;
  markFile: File | null;
  onMarkFileDownload: (file: File | null) => void;
  onHolterFileDownload: (file: File | null) => void;
};

export const FileUploader: FC<Properties> = ({ onMarkFileDownload, onHolterFileDownload, holterFile, markFile }) => {
  const dispatch = useAppDispatch();
  const { ecgCaptureId: ecgId, ecgLead, sampleRate: dbSampleRate } = useAppSelector(({ study }) => study.dbECGData);
  const [isLoading, setIsLoading] = useState(false);
  const [holterOffset, setHolterOffset] = useState(0);

  const handleMarkFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];

    if (file) {
      console.log('Found file ' + file.name);
      onMarkFileDownload(file);
      const reader = new FileReader();
      reader.onload = function (event) {
        const arrayBuffer = event.target.result as ArrayBufferLike;
        const dataView = new DataView(arrayBuffer);
        const fourByteIntegers = [];

        for (let i = 0; i < dataView.byteLength; i += 4) {
          // Check if there are at least 4 bytes remaining
          if (i + 1 < dataView.byteLength) {
            // Read four bytes and interpret as a signed 32-bit integer (little-endian)
            const marker = dataView.getInt32(i, true);
            fourByteIntegers.push(marker / 24);
            if (fourByteIntegers.length === 1) {
              console.log('setting offset to:' + marker / 24);
              setHolterOffset(marker / 24);
            }
            console.log('Marker found:' + marker);
          }
        }
        console.log('The Array is: ' + fourByteIntegers);
      };

      reader.readAsArrayBuffer(file);
    }
  };
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];

    if (file) {
      const reader = new FileReader();
      console.log('Last modified date is ' + String(new Date(file.lastModified)));
      console.log('THE everbeat ecgid is' + ecgId);
      reader.onload = async () => {
        setIsLoading(true);
        const response = await getCsvFromECG(file, ecgId, holterOffset);
        if (!response) {
          console.error('Error converting ECG to CSV:');
          setIsLoading(false);

          return;
        }
        const { lead1, offset: frequencyOffset, score } = response;
        const samples = lead1;
        const offset = frequencyOffset / dbSampleRate;
        console.log('The offset is: ' + frequencyOffset);
        const normalizeSamples = samples.map((x) => x * 5);
        const downloadEcgData: DownloadECGItem = {
          sampleRate: 512,
          ecgLead,
          patientName: ``,
          submittedTimestamp: file.lastModified,
          medicalRecordNumber: '',
          samples: normalizeSamples,
          ecgId,
          score,
          offset,
          analysis: `N/A`,
        };

        dispatch(studyActions.setDownloadECGData(downloadEcgData));
        onHolterFileDownload(file);
        setIsLoading(false);
      };

      reader.readAsText(file);
    } else {
      onHolterFileDownload(null);
      alert('Please select a valid .ECG file.');
    }
  };

  return (
    <div>
      <div className={styles.input_wrapper}>
        <div>
          <h4 className={styles.title}>{markFile ? 'Mark File Processed' : 'Select Mark file from Holter Monitor'}</h4>
          <input type='file' accept='.mrk' onChange={handleMarkFileChange} />
        </div>
        <div>
          <h4 className={styles.title}>{holterFile ? 'ECG File Selected' : 'Select ECG from Holter Monitor'}</h4>
          <input type='file' accept='.ecg' onChange={handleFileChange} />
        </div>
      </div>
      {isLoading && <div>Loading...</div>}
    </div>
  );
};
